export { default } from './ConfirmActionsContent';
